// src/universal/error-boundary/texts.ts
var texts = {
  title: "Something went wrong",
  message: "An unexpected error occurred in the application. Don't worry, this happens sometimes.",
  tryAgain: "Reload page"
};

export { texts };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-YZFUAOPE.mjs.map